import cx from 'classnames';
import { string, bool, oneOf, number, oneOfType } from 'prop-types';
import { Box, Loader } from '@chaser/components';
import style from './LoadingMessage.module.scss';

const width = size => ((59 / 15) * size).toFixed(1);

const ChaserPath =
  'M1.273 13.957a3.58 3.58 0 01-.79-1.224 3.526 3.526 0 01-.233-1.43V3.697c-.03-.477.045-.956.222-1.402.177-.446.45-.849.801-1.18A4.072 4.072 0 014.198.181a4.296 4.296 0 012.999.932c.342.336.604.741.769 1.188.164.446.226.923.181 1.395v1.077a.355.355 0 01-.107.253.37.37 0 01-.258.105H6.027a.37.37 0 01-.259-.105.355.355 0 01-.107-.253v-1.22a1.198 1.198 0 00-.354-1.016 1.247 1.247 0 00-1.035-.347 1.265 1.265 0 00-.985.378 1.215 1.215 0 00-.332.985v7.964a1.128 1.128 0 00.332.965 1.175 1.175 0 00.985.326c.95 0 1.389-.43 1.389-1.291V9.652c0-.095.038-.186.107-.253a.37.37 0 01.259-.105h1.755a.37.37 0 01.258.105.355.355 0 01.107.253v1.65c.042.49-.029.982-.206 1.441-.177.46-.456.874-.818 1.214a4.298 4.298 0 01-2.925.861 4.447 4.447 0 01-2.925-.86zM10.706.397h1.975a.37.37 0 01.258.105.356.356 0 01.107.254v5.453h2.852V.756a.429.429 0 01.152-.259.444.444 0 01.287-.1h1.901a.37.37 0 01.259.105.356.356 0 01.107.254v13.488a.356.356 0 01-.107.254.37.37 0 01-.259.105h-1.9a.443.443 0 01-.288-.1.429.429 0 01-.152-.259V8.218h-2.852v6.026a.356.356 0 01-.107.254.37.37 0 01-.258.105h-1.975a.37.37 0 01-.258-.105.355.355 0 01-.107-.254V.756c0-.095.038-.186.107-.254a.37.37 0 01.258-.105zM23.576.397h2.998a.518.518 0 01.44.287l2.632 13.489c0 .215-.147.43-.293.43h-2.047a.37.37 0 01-.236-.078.358.358 0 01-.13-.209l-.439-2.511h-2.998l-.439 2.511a.358.358 0 01-.13.209.37.37 0 01-.235.078h-1.755a.37.37 0 01-.259-.105.355.355 0 01-.107-.254L23.211.684a.504.504 0 01.365-.287zM26.21 9.94l-1.17-5.525h-.073l-1.17 5.525h2.413zM32.06 13.886a3.365 3.365 0 01-.811-1.217 3.315 3.315 0 01-.214-1.438v-.43c0-.096.039-.187.107-.254a.37.37 0 01.26-.105h1.827c.097 0 .19.038.259.105a.355.355 0 01.107.253v.36a1.197 1.197 0 00.354 1.015 1.248 1.248 0 001.035.347c.366.034.732-.068 1.024-.287a1.77 1.77 0 00.366-1.147 1.693 1.693 0 00-.512-1.292 7.762 7.762 0 00-1.755-1.65 8.628 8.628 0 01-2.34-2.224 3.963 3.963 0 01-.658-2.224c-.017-.477.065-.951.241-1.395a3.51 3.51 0 01.782-1.188c.413-.342.89-.6 1.404-.76A4.169 4.169 0 0135.13.182a4.02 4.02 0 011.56.175c.502.16.966.418 1.365.758.337.354.595.773.758 1.23.164.456.23.941.193 1.424v.216a.356.356 0 01-.107.253.37.37 0 01-.259.105h-1.755a.37.37 0 01-.258-.105.355.355 0 01-.107-.253 1.489 1.489 0 00-.366-1.077 1.48 1.48 0 00-1.024-.358c-.877 0-1.316.43-1.316 1.363a1.483 1.483 0 00.512 1.148 6.98 6.98 0 001.828 1.578 8.114 8.114 0 012.267 2.224c.428.693.656 1.486.658 2.296.028.5-.048.998-.224 1.467a3.647 3.647 0 01-.8 1.26 4.742 4.742 0 01-3.07.932 4.019 4.019 0 01-1.56-.175 3.969 3.969 0 01-1.366-.757zM41.565.397h6.581a.37.37 0 01.259.105.356.356 0 01.107.254v1.291a.356.356 0 01-.107.254.37.37 0 01-.259.105h-4.241V6.21h3.29c.097 0 .19.038.259.105a.355.355 0 01.107.253V7.86a.355.355 0 01-.107.254.369.369 0 01-.258.105h-3.291v4.376h4.241a.37.37 0 01.259.105.355.355 0 01.107.254v1.291a.426.426 0 01-.102.282.44.44 0 01-.264.149h-6.581a.44.44 0 01-.264-.149.426.426 0 01-.102-.282V.756c0-.095.039-.186.107-.254a.369.369 0 01.259-.105zM50.633.756c0-.095.038-.186.107-.254a.37.37 0 01.258-.105h3.657a4.822 4.822 0 012.998.79c.34.321.603.714.767 1.149.165.434.227.9.183 1.362v.86c0 1.436-.585 2.44-1.755 2.799.58.142 1.08.503 1.39 1.004a5.22 5.22 0 01.365 2.01v2.51c-.012.337.013.673.074 1.005a.423.423 0 00.073.287.283.283 0 01-.132.408.296.296 0 01-.16.022H56.41c-.147 0-.293-.072-.293-.215 0-.143-.073-.287-.146-.43v-3.66a1.69 1.69 0 00-.439-1.363 1.54 1.54 0 00-1.243-.43h-.95v5.74a.355.355 0 01-.108.253.369.369 0 01-.258.105h-1.975a.37.37 0 01-.258-.105.355.355 0 01-.107-.253V.755zm3.656 5.74a1.712 1.712 0 001.243-.359c.272-.32.403-.733.366-1.148V3.913a1.768 1.768 0 00-.293-1.148 1.483 1.483 0 00-1.023-.287h-1.244v4.018h.951z';

const LogoSvg = ({ color, size: h }) => (
  <svg width={width(h)} height={h} viewBox="0 0 59 15" fill="none" style={{ display: 'block' }}>
    <path fill={color} d={ChaserPath} />
  </svg>
);

const LoadingMessage = ({
  message = '',
  justifyContent = 'center',
  verticalAlign = 'inherit',
  margins = 'small',
  size = 33,
  center = false,
  p = 'small',
  spinner = true,
  elipses = false,
  overlay = false,
  className = undefined,
  useLogoAnimation = false,
  ...rest
}) => {
  return (
    <Box p={p} {...rest}>
      <div
        className={cx(
          !center ? style.loadingMessageContainer : style.loadingMessageContainer__center,
          style.margins[margins],
          elipses && style.ellipsesLoader,
          overlay && style.overlay,
          className,
        )}
        style={{
          justifyContent,
          verticalAlign,
        }}
        data-testid="spinner"
        data-trackingid="spinner"
      >
        {message}
        {spinner &&
          (useLogoAnimation ? (
            <div className={style.logoContainer}>
              <div className={style.logoBase}>
                <LogoSvg color="#E6E6E6" size={size} />
              </div>
              <div className={style.logoFill}>
                <LogoSvg color="#F5821F" size={size} />
              </div>
            </div>
          ) : (
            <Loader size={size} />
          ))}
      </div>
    </Box>
  );
};

export default LoadingMessage;

LoadingMessage.propTypes = {
  elipses: bool,
  spinner: bool,
  overlay: bool,
  p: oneOfType([string, number]),
  size: number,
  verticalAlign: string,
  message: string,
  center: bool,
  className: string,
  justifyContent: string,
  margins: oneOf(['small', 'none']),
  useLogoAnimation: bool,
};
